import { CircularProgress } from "@mui/material";

/** Should be used when you need to inline a spinning loading circle together with text */
export function SpinnerInline(): React.JSX.Element {
  return <CircularProgress size={15} />;
}
